import {styled} from "@mui/material/styles";
import {Box, TextField} from "@mui/material";

export const SearchFilterContainer = styled(Box)(({theme}) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(2),
    flexWrap: "wrap",
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        alignItems: "stretch",
    },
}))

export const SearchField = styled(TextField)(({theme}) => ({
    flexGrow: 1,
    maxWidth: "300px",
    [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
    },
}))

export const FilterField = styled(TextField)(({theme}) => ({
    width: "200px",
    [theme.breakpoints.down("sm")]: {
        width: "100%",
    },
}))

export const ItemsSelect = styled(TextField)(({theme}) => ({
    minWidth: "200px",
    [theme.breakpoints.down("sm")]: {
        width: "100%",
    },
}))